<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="
            !(ListLoadingErrorMessage == '' || ListLoadingErrorMessage == null)
          "
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ ListLoadingErrorMessage }}</strong>
        </div>
        <div
          v-if="!(errorMessage == '' || errorMessage == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-xs-3">
              <h3>Buy Requests</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 44px;
                  width: 195px;
                  float: right;
                  margin-left: 20px;
                  margin-right: 20px;
                "
              />
            </div>
          </div>
          <div
            v-if="!(userBank.Name == null || userBank.Name == '')"
            class="row"
          >
            <div class="col-md-6">
              <h3>{{ userBank.Name }}</h3>
            </div>
            <div class="col-md-6 text-right">
              <img
                style="padding: 10px"
                src="../../assets/imgs/BIsBR.png"
                v-hide="!(userBank.Name == null || userBank.Name == '')"
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />

            <!-- <input
              type="date"
              class="form-control"
              style="margin-left:4px;"
              placeholder="Start Date"
              v-model="startdate"
            >-->
            <date-pick
              style="margin-left: 4px"
              v-model="startdate"
              :format="'DD-MM-YYYY'"
              :inputAttributes="{
                class: 'form-control',
                placeholder: 'From Date',
              }"
            ></date-pick>
            <date-pick
              style="margin-left: 4px"
              v-model="enddate"
              :format="'DD-MM-YYYY'"
              :inputAttributes="{
                class: 'form-control',
                placeholder: 'To Date',
              }"
            ></date-pick>
            <!--
            <input
              type="date"
              class="form-control"
              style="margin-left:4px;"
              placeholder="End Date"
              v-model="enddate"
            >-->
            <a
              href="javascript:void(0)"
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="Filter"
              >Filter</a
            >
            <button
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="openModal(null)"
              v-if="RoleId && (RoleId.toString() == '4' || RoleId == 5)"
            >
              Add Request
            </button>
          </div>
          <div v-bind:id="'printable'" style="overflow-x: scroll">
            <strong v-currentdate>Current Date Time</strong>
            <table class="table table-bordered ng-grid" style="width: 100%">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('RefNo')"
                      >Ref No</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'RefNo'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('BankReference')"
                      >Your Reference</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'BankReference'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ClientName')"
                      >Client Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ClientName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('TransferOwner')"
                      >New Owner</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'TransferOwner'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('DepartmentName')"
                      >Department Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'DepartmentName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <!-- <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('TransferOwner')">New Owner</a>
                    <span
                      class="sortorder"
                      v-show="currentSort=='TransferOwner'"
                      :class="{'reverse':curentSortOrder=='desc'}"
                    ></span>
                  </th>-->
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ApplicationDate')"
                      >Transaction Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ApplicationDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ValueDate')"
                      >Value Date</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ValueDate'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>

                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Amount')"
                      >Amount</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Amount'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('CommodityName')"
                      >Commodity</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'CommodityName'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Quantity')"
                      >Quantity</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Quantity'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>

                  <th>Requested By</th>
                  <th>Physical Delivery</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td @click="openViewModal(option.RequestId)">
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.RefNo }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.BankReference }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.ClientName }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.TransferOwner }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.DepartmentName }}
                  </td>
                  <!-- <td>{{option.TransferOwner}}</td> -->
                  <td @click="openViewModal(option.RequestId)">
                    {{ DateFromat(option.ApplicationDate) }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ DateFromat(option.ValueDate) }}
                  </td>
                  <!-- <td @click="openViewModal(option.RequestId)">{{DateFromat(option.RequestDate)}}</td> -->

                  <td @click="openViewModal(option.RequestId)">
                    <span class="green" style="float: left">
                      {{ option.CurrencyShortname }}
                      <br />
                      {{ option.StringAmount }}
                    </span>
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.CommodityName }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.StringQuantity }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    {{ option.RequesterName }}
                  </td>
                  <td @click="openViewModal(option.RequestId)">
                    <span v-if="option.PhysicalDelivery">Yes</span>
                    <span v-else>No</span>
                  </td>
                  <td
                    @click="openViewModal(option.RequestId)"
                    class="img Print"
                    v-if="option.Accepted == true"
                  >
                    Purchaser Accepted
                  </td>
                  <td
                    @click="openViewModal(option.RequestId)"
                    class="img Print"
                    v-else
                  >
                    Pending
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row" style>
            <!-- <div
              class="pull-left"
              style="margin-left: 1%"
              v-if="RoleId && RoleId.toString() == '3'"
            >
              <input
                type="button"
                value="Accept Selected"
                @click="Accepted"
                class="btn btn-success"
              />
            </div> -->
            <div style="margin-top: -20px">
              <center class="loading-medium" v-if="ListLoading">
                <loading></loading>
              </center>
            </div>
          </div>

          <br />
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
        </div>
      </div>
    </div>
    <viewrequest
      v-if="viewmodal"
      :RequestId="RequestId"
      @Close="CloseModal"
      @Edit="EditRequest"
    ></viewrequest>
    <buyrequest
      v-if="showModal"
      :RequestId="RequestId"
      @Close="CloseModal"
    ></buyrequest>
  </div>
</template>

<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import viewrequest from "./ViewBuyRequest";
import buyrequest from "./buyRequests";
import DatePick from "vue-date-pick";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      currentPage: 1,
      viewmodal: false,
      selectList: [false],
      showModal: false,
      startdate: null,
      enddate: null,
      RequestId: null,
      Search: null,
      Allchecked: false,
      currentSort: "RefNo",
      curentSortOrder: "desc",
      userBank: { Name: null },
    };
  },
  components: {
    viewrequest,
    buyrequest,
    DatePick,
  },
  methods: {
    EditRequest() {
      this.viewmodal = false;
      this.showModal = true;
    },
    openViewModal(id) {
      this.RequestId = id;
      this.viewmodal = true;
    },

    MethodOrderBy() {
      var data = [...this.Request];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      return SortedArray;
    },
    // AcceptAll() {
    //   if (this.Allchecked) {
    //     for (var i = 0; i < this.selectList.length; i++) {
    //       this.selectList[i].value = true;
    //     }
    //   } else {
    //     var SortedArray = this.MethodOrderBy();
    //     this.selectList = [];
    //     for (var i = 0; i < SortedArray.length; i++) {
    //       this.selectList.push({
    //         value: SortedArray[i].Accepted,
    //         id: SortedArray[i].RequestId,
    //         accpted: SortedArray[i].Accepted,
    //       });
    //     }
    //   }
    // },

    CheckDates() {
      if (this.startdate == "") {
        this.startdate = null;
      }
      if (this.enddate == "") {
        this.enddate = null;
      }
    },
    // Accepted() {
    //   var params = new URLSearchParams();
    //   var _bool = false;
    //   var _index = 0;
    //   for (var i = 0; i < this.selectList.length; i++) {
    //     if (this.selectList[i].value) {
    //       if (
    //         this.selectList[i].accpted == null ||
    //         this.selectList[i].accpted == false
    //       ) {
    //         _bool = true;
    //         params.append(
    //           "ListModel[" + _index + "].Id",
    //           this.selectList[i].id
    //         );
    //         params.append(
    //           "ListModel[" + _index + "].Accept",
    //           this.selectList[i].value
    //         );
    //         _index++;
    //       }
    //     }
    //   }
    //   if (_bool) {
    //     params.append("TransactionType", "B");
    //     var vm = this;
    //     this.$store
    //       .dispatch(ACTIONS.SAVE_ACCEPTED_LIST, params)
    //       .then((res) => {
    //         var { data } = res;
    //         if (data && data.StatusCode == 200) {
    //           vm.GetData();
    //         } else {
    //           console.log(res);
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   }
    // },
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ListAcceptedId = [];
        this.ChnageUrl();
        this.GetData();
      }
    },
    CloseModal() {
      this.RequestId = null;
      this.showModal = false;
      this.viewmodal = false;
      this.GetData();
    },
    openModal(id) {
      this.RequestId = id;
      this.showModal = true;
    },
    Filter() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },
    ChnageUrl() {
      this.CheckDates();
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort +
        "&fromdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&todate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate));
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ListAcceptedId = [];
      this.ChnageUrl();
      this.GetData();
    },

    GetData() {
      this.CheckDates();
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&startdate=" +
        (this.startdate == null ? "" : this.GetCorrectFormat(this.startdate)) +
        "&enddate=" +
        (this.enddate == null ? "" : this.GetCorrectFormat(this.enddate));

      var vm = this;
      this.$store
        .dispatch(ACTIONS.BUY_REQUEST_GETALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
          // vm.ListAcceptedId = [];
          // var { data } = res;

          // if (data && data.StatusCode == 200) {
          //   var { buyRequests } = data.ResponseData;
          //   vm.selectList = buyRequests.map(a => a.RequesterAccepted);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
      if (
        this.$route.query.hasOwnProperty("fromdate") &&
        this.$route.query["fromdate"] != null &&
        this.$route.query["fromdate"] != ""
      ) {
        this.startdate = this.setFormDate(this.$route.query["fromdate"]);
      }
      if (
        this.$route.query.hasOwnProperty("todate") &&
        this.$route.query["todate"] != "" &&
        this.$route.query["todate"] != null
      ) {
        this.enddate = this.setFormDate(this.$route.query["todate"]);
      }
    }

    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      Request: "GETBUYREQUESTS",
      TotalRecords: "GETBUYREQUESTTOTATLPAGES",
      errorMessage: "GETBUYREQUESTERRORMESSAGE",
      loading: "GETBUYREQUESTLOADING",
      RoleId: "RoleId",
      // UserDept: "deptId",
      ListLoading: "GETACCEPTEDLISTLOADING",
      ListLoadingErrorMessage: "GETACCEPTEDLISTERRORMESSAGE",
      BankLogo: "GETBANKLOGO",
    }),
    OrderBy() {
      var data = [...this.Request];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }

      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      var _pageData = this.Pagination(SortedArray, sp, cp);
      this.selectList = [];
      for (var i = 0; i < _pageData.length; i++) {
        this.selectList.push({
          value: _pageData[i].Accepted,
          id: _pageData[i].RequestId,
          accpted: SortedArray[i].Accepted,
        });
      }
      return _pageData;
    },
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
  },
};
</script>

<style>
td span.green {
  float: left !important;
}
td span.green {
  color: green;
  float: right;
  font-weight: bold;
}
</style>
